import actions from './actions';

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
  namespaced: true,
};
